/* batida-nextday.js: "Zamów na jutro" facts for the shop texts (Aleksandra 4.10 17:17, the rule as in Batida Connect).
   The rule (Connect: availability.allLocations.tagCutoff {"24h": "21:00"}): a 24 h product is ready on the first OPEN day
   after today whose day before has not reached the cut-off yet (21:00 Warsaw). Open = not a Sunday and not one of
   Connect's closed days (the team's blackout days, e.g. 1.11, 11.11, 25-26.12). So:
     Mon-Fri before 21:00 -> tomorrow (order "dziś"); at/after 21:00 -> one day later;
     Saturday any time and Sunday before 21:00 -> Monday (order "do niedzieli" / "dziś"); Sunday after 21:00 -> Tuesday;
     the day before a closed day -> the next open day (order by 21:00 on the closed day).
   Data: GET /apps/connect/kalendarz (app proxy) -> today, nextDayCutoff ("21:00" while the rule is on, else null),
   closed [{date}]; kept 6 h in localStorage. Until it answers (or when it fails) Sundays alone are used with 21:00.
   nextDayCutoff null = Connect has no cut-off rule: get() gives null and every text keeps its server-rendered words.
   Used by:
     - window.BatidaNextDay.get() / compute(): assets/batida-konto.js (Moje konto countdown), assets/batida-v7-kalendarz.js
       (name-day line);
     - [data-bnd-later="<template>"] elements (header strip "Jutro jest okazja? Zamów dziś", home tile "Zamów dziś. Jutro
       przyjmuj komplementy."): the server text stays while tomorrow can still be ordered today; otherwise the element
       shows the template with {termin} ("do niedzieli"), {kiedy} ("w poniedziałek"), {godzina} ("21:00"), {termin_cap},
       {kiedy_cap}. Words: JSON [data-bnd-t] from snippets/batida-nextday.liquid (locale keys batida.v7.nd_*).
   Testing: ?bnd_now=2026-10-10T15:00 (Warsaw wall time) pretends that moment in this tab (kept in sessionStorage, the
   clock runs on from it); ?bnd_now=0 ends it. Display only - nothing is ordered or saved. */
(function () {
  'use strict';
  if (window.BatidaNextDay) return;

  var FMT = typeof Intl !== 'undefined' && Intl.DateTimeFormat ? new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }) : null;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function wParts(d) {
    var o = {};
    FMT.formatToParts(d).forEach(function (x) { o[x.type] = x.value; });
    var h = +o.hour === 24 ? 0 : +o.hour;
    return { y: +o.year, m: +o.month, d: +o.day, h: h, mi: +o.minute, s: +o.second, ymd: o.year + '-' + o.month + '-' + o.day, hm: pad(h) + ':' + o.minute };
  }
  /* the instant of a Warsaw wall-clock time */
  function wInstant(ymd, hm) {
    var a = String(ymd).split('-').map(Number), b = String(hm || '00:00').split(':').map(Number);
    var guess = Date.UTC(a[0], a[1] - 1, a[2], b[0] || 0, b[1] || 0), t = guess;
    for (var i = 0; i < 2; i++) { var p = wParts(new Date(t)); t = guess - (Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - t); }
    return t;
  }
  function utc(ymd) { var a = String(ymd).split('-').map(Number); return Date.UTC(a[0], a[1] - 1, a[2]); }
  function addDays(ymd, n) { return new Date(utc(ymd) + n * 864e5).toISOString().slice(0, 10); }
  function dow(ymd) { return new Date(utc(ymd)).getUTCDay(); }
  function dm(ymd) { var a = String(ymd).split('-'); return (+a[2]) + '.' + a[1]; }

  /* ---------- test clock (?bnd_now=YYYY-MM-DDTHH:MM, Warsaw) ---------- */
  var MOCK = null;
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  try {
    var q = new URLSearchParams(location.search).get('bnd_now');
    if (q === '0') sset('bnd-now', null);
    else if (q && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(q)) sset('bnd-now', JSON.stringify({ wall: q, at: Date.now() }));
    var m = JSON.parse(sget('bnd-now') || 'null');
    if (m && m.wall && FMT) MOCK = { t0: wInstant(m.wall.slice(0, 10), m.wall.slice(11)), at: m.at };
  } catch (e) {}
  function now() { return MOCK ? MOCK.t0 + (Date.now() - MOCK.at) : Date.now(); }

  /* ---------- the rule ---------- */
  function compute(t, closed, cutoff) {
    if (!FMT || !/^\d{1,2}:\d{2}$/.test(String(cutoff || ''))) return null;
    var shut = {};
    (closed || []).forEach(function (c) { shut[typeof c === 'string' ? c : c && c.date] = true; });
    var today = wParts(new Date(t)).ymd;
    for (var i = 1; i <= 40; i++) {
      var day = addDays(today, i);
      if (dow(day) === 0 || shut[day]) continue;                      // Sundays and closed days: nothing handed over
      var deadline = addDays(day, -1), at = wInstant(deadline, cutoff);
      if (t < at) {
        return { now: t, today: today, cutoff: cutoff, day: day, deadline: deadline, deadlineAt: at,
          deadlineToday: deadline === today, dayTomorrow: day === addDays(today, 1), deadlineTomorrow: deadline === addDays(today, 1) };
      }
    }
    return null;
  }

  /* ---------- Connect's calendar (app proxy), 6 h in localStorage ---------- */
  var KEY = 'bnd:v1', data = null, pending = null;
  function lget() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function lset(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function from() { return FMT ? wParts(new Date(now())).ymd : ''; }
  (function () { var c = lget(); if (c && c.from === from() && Date.now() - c.at < 216e5) data = c; })();
  function load() {
    if (pending) return pending;
    var f = from();
    pending = fetch('/apps/connect/kalendarz?days=21&lang=pl' + (MOCK ? '&from=' + f : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.ok && j.enabled) {
          data = { from: f, at: Date.now(), cutoff: j.nextDayCutoff || null, closed: (j.closed || []).map(function (c) { return c.date; }) };
          lset(data);
        }
        return data;
      })
      .catch(function () { return data; })
      .then(function (d) { pending = null; return d; });
    return pending;
  }
  /* the facts now: Connect's data when known (null when Connect has no cut-off rule), else Sundays + 21:00 */
  function current() {
    if (data) return data.cutoff ? compute(now(), data.closed, data.cutoff) : null;
    return compute(now(), [], '21:00');
  }
  function get() { return load().then(current); }

  /* ---------- words ---------- */
  var W = null;
  function words() {
    if (W) return W;
    var el = document.querySelector('[data-bnd-t]');
    try { W = el ? JSON.parse(el.textContent) : {}; } catch (e) { W = {}; }
    return W;
  }
  function list(v) { return String(v || '').split(',').map(function (x) { return x.trim(); }); }
  function cap(s) { s = String(s || ''); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  /* {termin}: "dziś" / "do niedzieli"; {kiedy}: "jutro" / "w poniedziałek"; {godzina}: "21:00"; {data}: "5.10" */
  function vars(info, w) {
    w = w || words();
    var by = list(w.by_days), on = list(w.on_days);
    var termin = info.deadlineToday ? (w.today || '') : (by[dow(info.deadline)] || '');
    var kiedy = info.dayTomorrow ? (w.tomorrow || '') : (on[dow(info.day)] || '');
    return { termin: termin, termin_cap: cap(termin), kiedy: kiedy, kiedy_cap: cap(kiedy), godzina: info.cutoff, data: dm(info.day) };
  }
  function fill(t, v) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return v && v[k] != null ? v[k] : ''; }); }

  /* ---------- [data-bnd-later] texts ---------- */
  function apply() {
    var els = document.querySelectorAll('[data-bnd-later]');
    if (!els.length) return;
    var info = current(), w = words();
    [].forEach.call(els, function (el) {
      if (el.__bnd0 == null) el.__bnd0 = el.innerHTML;
      var later = info && !info.deadlineToday && w.by_days && w.on_days;
      var txt = later ? fill(el.getAttribute('data-bnd-later'), vars(info, w)) : null;
      if (txt) { if (el.textContent !== txt) el.textContent = txt; el.setAttribute('data-bnd', 'later'); }
      else if (el.getAttribute('data-bnd') === 'later') { el.innerHTML = el.__bnd0; el.setAttribute('data-bnd', 'tomorrow'); }
    });
  }

  window.BatidaNextDay = { now: now, mocked: !!MOCK, compute: compute, get: get, current: current, vars: vars, fill: fill, apply: apply,
    wParts: wParts, wInstant: wInstant, addDays: addDays, dow: dow, dm: dm };
  try { document.dispatchEvent(new CustomEvent('bnd:ready')); } catch (e) {}

  function start() {
    apply();
    if (document.querySelector('[data-bnd-later]')) load().then(apply);
    setInterval(apply, 60000);                       // 21:00 and midnight pass while the page is open
    document.addEventListener('visibilitychange', function () { if (!document.hidden) apply(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
